import { render } from "./selectCodigoPostal.vue?vue&type=template&id=6c395fba"
import script from "./selectCodigoPostal.vue?vue&type=script&lang=ts"
export * from "./selectCodigoPostal.vue?vue&type=script&lang=ts"
script.render = render

export default script